module.exports = __webpack_public_path__ + "img/search-dark.84bdd2ea.svg";